module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true,
      "fix-height": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('ReChallengeIcon', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Re-challenge "), (_vm.isSingleForecastWindow) ? [_vm._v(_vm._s(_vm.forecastWindows[0].zone.name))] : _vm._e()], 2)], 1), _vm._v(" "), (_vm.forecastWindows.length > 1) ? _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Select the markets you would like to (re)submit forecasts : "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "selector"
  }, [(_vm.isSelectAllActive) ? _c('ClientColorButton', {
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("Select all")]) : _c('ClientColorButton', {
    on: {
      "click": function($event) {
        _vm.selectedForecastWindows = []
      }
    }
  }, [_vm._v("Select none")])], 1), _vm._v(" "), _vm._l((_vm.forecastWindows), function(forecastWindow) {
    return _c('div', {
      key: forecastWindow.id,
      staticClass: "option"
    }, [_c('ZoneStatus', {
      attrs: {
        "forecast-window": forecastWindow
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedForecastWindows),
        expression: "selectedForecastWindows"
      }],
      attrs: {
        "id": ("forecastWindow_" + (forecastWindow.id)),
        "type": "checkbox",
        "disabled": !_vm.hasUserAccessToForecastWindow(forecastWindow) || _vm.isDeleted(forecastWindow.zone)
      },
      domProps: {
        "value": forecastWindow,
        "checked": Array.isArray(_vm.selectedForecastWindows) ? _vm._i(_vm.selectedForecastWindows, forecastWindow) > -1 : (_vm.selectedForecastWindows)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedForecastWindows,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = forecastWindow,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedForecastWindows = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedForecastWindows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedForecastWindows = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        disabled: !_vm.hasUserAccessToForecastWindow(forecastWindow)
      },
      attrs: {
        "for": ("forecastWindow_" + (forecastWindow.id))
      }
    }, [_vm._v("\n                        " + _vm._s(forecastWindow.zone.name) + " "), (_vm.isDeleted(forecastWindow.zone)) ? _c('span', [_c('i', [_vm._v("(DELETED)")])]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "multiValidation",
      class: {
        hidden: !forecastWindow.multiValidation
      }
    }, [_c('MarketIcon')], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message : "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "id": "message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.isValid || _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Re-challenge")])], 1)])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2021d9b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ReChallengeModal.vue
// module id = 3072
// module chunks = 0